export const getOnboardingSteps = (searchParams, initialNodesData) => {
  const onboardingSteps = [];

  //IMPORTANTE ES LA CANTIDAD DE PASOS DEL ONBOARDING
  const pasosOnboarding = 12;

  for (let i = 1; i <= pasosOnboarding; i++) {
    const hasStep = searchParams.get(`hasonboardingstep${i}`);
    const stepCode = searchParams.get(`codeonboardingstep${i}`);
    if (hasStep === "t" && stepCode) {
      const node = initialNodesData.find(
        (n) => n.id.toUpperCase() === stepCode.toUpperCase() && n.line === 1
      );
      if (node) {
        onboardingSteps.push(node);
      }
    }
  }

  return onboardingSteps;
};
